import { render } from "./libutton.vue?vue&type=template&id=a8cde12c"
import script from "./libutton.vue?vue&type=script&lang=js"
export * from "./libutton.vue?vue&type=script&lang=js"
script.render = render

export default script